module.exports = __webpack_public_path__ + "assets/GoldOmicron2x.f6618a3aee9075ef1086ad018fcb2dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldOmicron2x.png
// module id = 817
// module chunks = 0